/** Labels for SME / lesson flow; codes should match `slidetypemaster.slideTypeShortcode` when possible. */
export const FALLBACK_SME_SLIDE_TYPES: { code: string; label: string }[] = [
  { code: 'START', label: 'Start Slide' },
  { code: 'BLCC', label: 'Bullet List with Close Caption' },
  { code: 'IMAGECC', label: 'Image with Close Caption' },
  { code: 'IMAGEBLCC', label: 'Image with Bullet List and Close Caption' },
  { code: 'CONV', label: 'Conversation' },
  { code: 'IMAGECONV', label: 'Image with Conversation' },
  { code: 'TABLE', label: 'Table' },
  { code: 'IMAGECOLCC', label: 'Image with Columnar Close Caption' },
  { code: 'PBL', label: 'Picture and bullets' },
  { code: 'QUIZ', label: 'Quiz' },
  { code: 'PQUIZ', label: 'Quiz with picture' },
  { code: '2COLBLCC', label: 'Two Column Bullet List with Close Caption' },
];

export function mapApiSlideTypesToOptions(rows: unknown): { code: string; label: string }[] {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [...FALLBACK_SME_SLIDE_TYPES];
  }
  const out = rows
    .map((r: any) => ({
      code: String(r?.slideTypeShortcode ?? '').trim(),
      label: String(r?.slideTypeName ?? r?.slideTypeShortcode ?? '').trim(),
    }))
    .filter((o) => o.code.length > 0);
  return out.length > 0 ? out : [...FALLBACK_SME_SLIDE_TYPES];
}
